import { Box } from "@mui/material";
import { Loader, Select } from "@trimble/modus-cmx";
import { useTranslation } from "react-i18next";
import { getModusEventTarget } from "@/utils/modusEvents";

type CountryOption = {
  value: string;
  label: string;
};

type ProductPricelistCountrySelectProps = {
  countryCode: string;
  options: CountryOption[];
  onCountryChange: (code: string) => void;
  loading?: boolean;
  fullWidth?: boolean;
  label?: string;
  required?: boolean;
};

function ProductPricelistCountrySelect({
  countryCode,
  options,
  onCountryChange,
  loading = false,
  fullWidth = false,
  label,
  required = false,
}: ProductPricelistCountrySelectProps) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        position: "relative",
        width: fullWidth ? "100%" : undefined,
        minWidth: fullWidth ? undefined : 150,
      }}
    >
      <Select
        label={label}
        required={required}
        aria-label={t("product_pricelist.country")}
        data-testid="product-pricelist-country"
        disabled={loading}
        fullWidth={fullWidth}
        options={options}
        value={countryCode}
        onInputChange={(event) => {
          const select = getModusEventTarget(event, HTMLSelectElement);
          if (select) {
            onCountryChange(select.value);
          }
        }}
      />
      {loading ? (
        <Box
          aria-hidden="true"
          sx={{
            position: "absolute",
            top: "50%",
            right: "2.5rem",
            transform: "translateY(-50%)",
            pointerEvents: "none",
          }}
        >
          <Loader size="sm" />
        </Box>
      ) : null}
    </Box>
  );
}

export default ProductPricelistCountrySelect;
